import {
    type formatCreatorsAttribute_viewer$data,
    type formatCreatorsAttribute_viewer$key,
} from './__generated__/formatCreatorsAttribute_viewer.graphql';

import { graphql, readInlineData } from 'react-relay/legacy';

const getStyleName = (attrVal: string, viewer: formatCreatorsAttribute_viewer$data): string => {
    const prop = viewer?.creatorProperties?.find(
        _prop => _prop?.propertyName === 'creatorStyle' && _prop?.urlLabel === attrVal
    );
    return prop?.name || attrVal;
};

const getNationalityName = (
    attrVal: string,
    viewer: formatCreatorsAttribute_viewer$data
): string => {
    const prop = viewer?.creatorProperties?.find(
        _prop => _prop?.propertyName === 'creatorNationality' && _prop?.urlLabel === attrVal
    );
    return prop?.name || attrVal;
};

export const formatCreatorsAttribute = (
    attrName: string,
    attrVal: string,
    viewerRef: formatCreatorsAttribute_viewer$key
): string => {
    const viewer = readInlineData(
        graphql`
            fragment formatCreatorsAttribute_viewer on Viewer @inline {
                creatorProperties(names: ["creatorNationality", "creatorStyle"]) {
                    propertyName
                    urlLabel
                    name
                }
            }
        `,
        viewerRef
    );

    if (attrName === 'nationality') {
        return getNationalityName(attrVal, viewer);
    }

    if (attrName === 'style') {
        return getStyleName(attrVal, viewer);
    }

    return attrName;
};
